var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "message-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 1h13v13H2z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#message-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.042.998H4.708A2.71 2.71 0 0 0 2 3.706v6.963a1.163 1.163 0 0 0 1.81.969l2.146-1.432h3.086a2.71 2.71 0 0 0 2.708-2.708V3.706A2.71 2.71 0 0 0 9.042.998M15 5.873v6.962a1.163 1.163 0 0 1-1.809.97l-2.147-1.432H7.958a2.7 2.7 0 0 1-1.983-.878l.309-.205h2.758a3.797 3.797 0 0 0 3.791-3.792V3.706q-.002-.25-.035-.49A2.71 2.71 0 0 1 15 5.872"
}))));
export { SvgMessageIcon as ReactComponent };
export default __webpack_public_path__ + "b42a932ecccea79a08e79543619146d2.svg";